// polyfills for everyone's favorite browser, Internet Exploder
import 'unfetch/polyfill';
import 'abortcontroller-polyfill';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';

import { sorts } from './utils';
import { getFacetConfig } from './config';

const base =
  process.env.NODE_ENV == 'production'
    ? '/api/v1/solr'
    : '//qual-msn-src02.qualtim.local:8983/solr/drj-d9/select'; // '//qual-msn-src02.qualtim.local:8983/solr/drj-d9/select' : '//localhost:9998/solr/lando/select';

(async () => {
  const facets = await getFacetConfig();
  ReactDOM.render(
    <App
      solrURL={base}
      showInitialResults={false}
      filters={{ index_id: 'drj', site: '*' }}
      facets={facets}
      sorts={sorts}
      itemsPerPage={15}
      defaultSort={{ field: 'score', direction: 'desc' }}
      defaultFilter={{
        ss_type: 'sealed_document',
        itm_field_report_type: ['581', '730', '750', '939', '940', '941'],
        bs_field_legacy_document: false
      }}
    />,
    document.getElementById('root')
  );
})();
